import { KnownBusinessEntityContactRepository } from "@/repositories/known-business-entity-contact-repository"
import { type IKnownBusinessEntityContact } from "@/interfaces/api/known-business-entity-contact.interface.ts"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { useKnownBusinessEntitiesContactsStore } from "@/store/known-business-entities-contacts.store.ts"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class KnownBusinessEntityContactController extends GenericModelController<
  KnownBusinessEntityContact,
  IKnownBusinessEntityContact,
  KnownBusinessEntityContactRepository
> {
  constructor() {
    const knownBusinessEntitiesContactsStore = useKnownBusinessEntitiesContactsStore()
    const { knownBusinessEntitiesContacts } = storeToRefs(knownBusinessEntitiesContactsStore)
    const storeFunctionsConfig = {
      collection: knownBusinessEntitiesContacts
    }
    super(
      KnownBusinessEntityContact,
      storeFunctionsConfig,
      new KnownBusinessEntityContactRepository()
    )

    useSocketSynchronizationHandlers(KnownBusinessEntityContact, knownBusinessEntitiesContacts)
  }
}
